import {
  LOAD_SCHEMAS_FROM_STOCK_BEGIN,
  LOAD_SCHEMAS_FROM_STOCK_SUCCESS,
  LOAD_SCHEMAS_FROM_STOCK_FAILURE,
  LOAD_SCHEMAS_FROM_STOCK_DISMISS_ERROR,
} from './constants'

import { processDefaultAndTotals } from '../../common/formulario/processDefaultAndTotals'
import { getCatalogSchema } from '../../car-data-catalogo/redux/getCatalogSchema'
import mock0km from '../stock_mock_data_0km'
import mockUsado from '../stock_mock_data_usado'
import mockUsadoProntoEnStock from '../stock_mock_data_usado_pronto_en_stock'

export function loadSchemasFromStock() {  
  return (dispatch)=> {
    // optionally you can have getState as the second argument
    dispatch({
      type: LOAD_SCHEMAS_FROM_STOCK_BEGIN,
    })

    const promise = new Promise((resolve, reject) => {
     // TODO: sacar schema en info basica y usar maquetacion html
      const doRequest = getCatalogSchema()
      doRequest.then(
        res => {
          const {
            defaults: advancedInfoDefaults,
            countTotalFields: advancedInfoTotalFields
          } = processDefaultAndTotals(res.data.data.advancedInfoSchema)
          const {
            defaults: basicInfoUsadoDefaults,
            countTotalFields: basicInfoUsadoTotalFields,
            required: basicInfoUsadoRequired,
          } = processDefaultAndTotals(mockUsado.data.data.basicInfoSchema)
          const {
            defaults: basicInfoNuevoDefaults,
            countTotalFields: basicInfoNuevoTotalFields,
            required: basicInfoNuevoRequired,
          } = processDefaultAndTotals(mock0km.data.data.basicInfoSchema)
          dispatch({
            type: LOAD_SCHEMAS_FROM_STOCK_SUCCESS,
            data: {
              basicInfoUsadoSchema: mockUsado.data.data.basicInfoSchema,
              basicInfoUsadoProntoEnStockSchema: mockUsadoProntoEnStock.basicInfoSchema,
              basicInfoNuevoSchema: mock0km.data.data.basicInfoSchema,
              advancedInfoTotalFields,
              basicInfoUsadoTotalFields,
              basicInfoNuevoTotalFields,
              advancedInfoSchema: res.data.data.advancedInfoSchema,
              requiredFieldsUsado: {
                ...basicInfoUsadoRequired /* ...advancedInfoRequired */,
              },
              requiredFieldsNuevo: {
                ...basicInfoNuevoRequired /* ...advancedInfoRequired */,
              },
              defaults: {
                ...advancedInfoDefaults,
                ...basicInfoUsadoDefaults,
                ...basicInfoNuevoDefaults,
              },
            },
          })
          resolve({
            ...advancedInfoDefaults,
            ...basicInfoUsadoDefaults,
            ...basicInfoNuevoDefaults,
          })
        },
        //Use rejectHandler as the second argument so that render errors won't be caught.
        err => {
          dispatch({
            type: LOAD_SCHEMAS_FROM_STOCK_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })
    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadSchemasFromStockError() {
  return {
    type: LOAD_SCHEMAS_FROM_STOCK_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case LOAD_SCHEMAS_FROM_STOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadSchemasFromStockPending: true,
        loadSchemasFromStockError: null,
      }

    case LOAD_SCHEMAS_FROM_STOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        loadSchemasFromStockPending: false,
        loadSchemasFromStockError: null,
        ...action.data,
      }

    case LOAD_SCHEMAS_FROM_STOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        loadSchemasFromStockPending: false,
        loadSchemasFromStockError: action.data.error,

        totalFields: 0,
        advancedInfoSchema: null,
        requiredFields: null,
      }

    case LOAD_SCHEMAS_FROM_STOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadSchemasFromStockError: null,
      }

    default:
      return state
  }
}
